import { z } from 'zod';

export const JoinOrganizationNetworkParamsSchema = z.object({
  organizationId: z.uuid(),
  networkId: z.uuid(),
});

export type JoinOrganizationNetworkParams = z.infer<typeof JoinOrganizationNetworkParamsSchema>;

export const JoinOrganizationNetworkBodySchema = z.object({
  placeIds: z.array(z.uuid()),
  agreementType: z.enum(['exclusive', 'preferred', 'partial']),
  contractReference: z.string().nullable().optional(),
  validFrom: z.iso.date().optional(),
});

export type JoinOrganizationNetworkBody = z.infer<typeof JoinOrganizationNetworkBodySchema>;

export const JoinOrganizationNetworkResponseSchema = z.object({
  membershipId: z.uuid(),
});

export type JoinOrganizationNetworkResponse = z.infer<typeof JoinOrganizationNetworkResponseSchema>;
